import React, { useState, useEffect } from 'react';
import StatsCard from './StatsCard';

function StatsCardsBlock({ totalSelectedValue, dataStatsProp }) {
  const [selectedQueueForStats, setSelectedQueueForStats] =
    useState(totalSelectedValue);
  const [dataStats, setDataStats] = useState(dataStatsProp);
  useEffect(() => {
    setSelectedQueueForStats(totalSelectedValue);
  }, [totalSelectedValue]);
  useEffect(() => {
    setDataStats(dataStatsProp)
  }, [dataStatsProp])

  return (
    <div className="stats-cards-container">
      <StatsCard
        testid="stats-card-total-queues"
        title="Total Queues"
        value={selectedQueueForStats || 0}
      />
      <StatsCard
        testid="stats-card-served"
        title="Guests Served"
        value={dataStats.guestsServed || 0}
      />
      <StatsCard
        testid="stats-card-average-time"
        title="Average Wait Time"
        value={`${dataStats.averageWaitTime} mins`}
      />
      <StatsCard
        testid="stats-card-removed"
        title="Guests Removed"
        value={dataStats.canceledGuests || 0}
      />
      <StatsCard
        testid="stats-card-waiting"
        title="Guests Waiting"
        value={dataStats.waitingGuests || 0}
      />
    </div>
  );
}

export default StatsCardsBlock;
